import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import {
    makeStyles
} from "@mui/styles";
import {
    Grid,
    TextField,
    Button
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles({
    root: {
        background: 'linear-gradient(90deg,#d92cc1,#0b1b37)',
        textAlign: 'center',
        height: "100vh",
        overflowY: "scroll"
    },
    inner: {
        maxWidth: '1200px',
        margin: 'auto',
        padding: "30px"
    },
    title: {
        margin: 0,
        color: 'white'
    },
    section: {
        marginTop: "50px",
        backgroundColor: 'rgba(255, 255, 255, 0.1215686275)',
        padding: '40px !important'
    },
    rightBorder: {
        borderRight: '1px solid #c0bdbd80'
    },
    leftColumn: {
        padding: "20px",
        paddingRight: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    inputField: {
        width: "100%",
        marginBottom: "20px !important",
        color: "white",
        '& .MuiInputLabel-outlined': {
            color: '#ffffff8c'
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#ffffff8c'
        },
        '& .MuiFormLabel-root': {
            fontSize: "15px",
            color: "#ffffff8c"
        },
        "& .MuiInputBase-input": {
            fontSize: "15px",
            color: "#ffffff8c"
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#ffffff8c'
            },
            '&:hover fieldset': {
                borderColor: '#ffffff8c'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ffffff8c'
            },
        },
    },
    forgotPassword: {
        marginTop: "-15px",
        textAlign: "right",
        fontSize: "15px",
        color: "white",
        textDecoration: "none",
        display: "block"
    },
    button: {
        marginTop: "20px !important",
        width: "100%",
        backgroundColor: 'white !important',
        color: "black !important",
        padding: "10px !important"
    },
    image: {
        width: "100%",
        height: "auto"
    }
});

const Login = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const showSuccess = (message) => {
        toast.success(message);
    }

    const showError = (message) => {
        toast.error(message);
    }

    const handleValidation = () => {
        var isValid = true;

        if (!email.trim()) {
            isValid = false;
            setEmailError("*Email is required.");
        }
        else {
            setEmailError("");
        }

        if (!password.trim()) {
            isValid = false;
            setPasswordError("*Password is required.");
        }
        else {
            setPasswordError("");
        }
        return isValid;
    }

    const onLoginFormSubmit = (e) => {
        e.preventDefault();

        if (handleValidation()) {
            axios
                .post(process.env.REACT_APP_API_URL + "/" + process.env.REACT_APP_API_VERSION + "/auth/web/login", {
                    email: email,
                    password: password
                })
                .then(response => {
                    if (response.data) {
                        localStorage.setItem("userToken", response.data.data?.access?.token);
                        navigate("/dashboard");
                    }
                    else {
                        showError(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response?.status == 400) {
                        showError(error.response?.data?.message);
                    }
                    else {
                        showError(error.message);
                    }
                });
        }
    }

    return (
        <Grid className={classes.root}>
            <ToastContainer />
            <Grid className={classes.inner}>
                <h1 className={classes.title}>Login</h1>

                <Grid container className={classes.section}>
                    <Grid xs={6} className={[classes.rightBorder, classes.leftColumn]}>
                        <form onSubmit={onLoginFormSubmit}>
                            <TextField
                                label="Email"
                                type="text"
                                variant="outlined"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={classes.inputField}
                                error={!!emailError}
                                helperText={emailError}
                            />
                            <TextField
                                label="Password"
                                variant="outlined"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={classes.inputField}
                                error={!!passwordError}
                                helperText={passwordError}
                            />
                            <Link
                                to={"/"}
                                className={classes.forgotPassword}>Forgot Password?</Link>
                            <Button
                                variant="contained"
                                className={classes.button}
                                type="submit"
                            >Login</Button>
                        </form>
                    </Grid>
                    <Grid xs={6}>
                        <img
                            src={require("../../assets/images/login.png")}
                            className={classes.image}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Login;